export const androidAwardsData = {
  title: 'awards',
  leadText:
    'Leading review & rating piatforms name us the top mobile app development company',
  leadImage: '/ios/rate.png',
  list: [
    {
      image: '/awards/item-1.jpg',
      text: 'Top Web Developers in Spain',
      title: 'Clutch',
    },
    {
      image: '/awards/item-2.jpg',
      text: 'Top Web Design in Spain',
      title: 'Clutch',
    },
    {
      image: '/awards/item-3.jpg',
      text: 'Top Swift App Development in Spain',
      title: 'Clutch',
    },
    {
      image: '/awards/item-4.jpg',
      text: 'Top Web Developers in Ukraine',
      title: 'Goodfirm',
    },
    {
      image: '/awards/item-5.jpg',
      text: 'Upwork TOP RATED 2022',
      title: 'Upwork',
    },
    {
      image: '/awards/item-6.jpg',
      text: 'Top Web Developers Companies 2020',
      title: 'Appfutura',
    },
  ],
};

export const androidIntroData = {
  bg: '/android/intro-bg.jpg',
  btn: 'Estimate my app',
  h1: 'android',
  h2: 'App Development',
};

export const androidTechData = {
  title: 'Platforms',
  list: [
    {
      image: '/ios/device-1.jpg',
      name: 'Smartphone',
    },
    {
      image: '/ios/device-2.jpg',
      name: 'Tablet',
    },
    {
      image: '/ios/device-3.jpg',
      name: 'Smart Watch',
    },
  ],
};

export const androidServiceData = {
  title: 'Android Development Services',
  list: [
    {
      image: '/ios/service-1.jpg',
      title: 'UX and UI design',
      text: 'We feel what you need and we know how to make it convenient for users. We guarantee that the design for Android mobile app will convey the main idea, mood and solutions of the application.',
    },
    {
      image: '/ios/service-2.jpg',
      title: 'Implementation',
      text: 'Android mobile development needs planning, prioritizing tasks to the top, using different technologies. Our clients are always aware of the current development status and are watching the development in progress.',
    },
    {
      image: '/ios/service-3.jpg',
      title: 'Quality Assurance',
      text: 'Development of Android mobile app always requires testing. The cost of all applications is that they are free of bugs. Our team prepares test plans, test cases and bug reports so that the application meets all standards.',
    },
    {
      image: '/ios/service-4.jpg',
      title: 'Integration Process',
      text: 'For sure, the integration of applications for Android phones and tablet is essential to improve efficiency, speed and quality. Development of the Android mobile applications does not stand still.',
    },
  ],
};

export const androidDevtoolsData = {
  title: 'Android technologies we work with',
  list: [
    { image: '/android/devtool-1.png', name: 'Android Studio' },
    { image: '/android/devtool-2.png', name: 'Intellij IDEA ' },
    { image: '/android/devtool-3.png', name: 'Android Debug' },
    { image: '/android/devtool-4.png', name: 'Appium' },
    { image: '/android/devtool-5.png', name: 'Firebase' },
  ],
};
